export default __webpack_public_path__ + "static/media/no-access.586de241.svg";